import { render, staticRenderFns } from "./InputPrice.vue?vue&type=template&id=49884087&scoped=true"
import script from "./InputPrice.vue?vue&type=script&lang=js"
export * from "./InputPrice.vue?vue&type=script&lang=js"
import style0 from "./InputPrice.vue?vue&type=style&index=0&id=49884087&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49884087",
  null
  
)

export default component.exports